<template>
  <div class="bk-blokkli-item-options-color">
    <input v-model="text" type="color" />
    <div
      class="bk-blokkli-item-options-color-preview"
      :style="{
  backgroundColor: modelValue
}"
    />
    <div class="bk-blokkli-item-options-color-label">{{ text }}</div>
  </div>
</template>

<script setup>
import { computed } from "#imports";
const props = defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, required: false }
});
const emit = defineEmits(["update:modelValue"]);
const text = computed({
  get() {
    return props.modelValue || "";
  },
  set(v) {
    emit("update:modelValue", (v === void 0 ? "" : v).toString());
  }
});
</script>

<script>
export default {
  name: "OptionsFormColor"
};
</script>
